import { type ReactElement } from 'react';
import SolutionPageLayout from '../../components/features/SolutionPageLayout';

export default function Startups(): ReactElement {
  return (
    <SolutionPageLayout
      badge="Für Startups"
      title="Buchhaltung für Startups – skalierbar von Tag 1"
      subtitle="Ihr Startup wächst schnell? Saldify wächst mit. Von der Gründung bis zur Finanzierungsrunde – immer die richtige Lösung."
      heroImage="/screenshots/app-kennzahlen.webp"
      heroImageAlt="Kennzahlen und Umsatzentwicklung in Saldify"
      introTitle="Fokus auf Wachstum, nicht auf Papierkram"
      introText="Als Gründer haben Sie eine Vision. Buchhaltung gehört selten dazu. Saldify automatisiert die lästigen Aufgaben, damit Sie sich auf Ihr Produkt und Ihre Kunden konzentrieren können."
      introBullets={[
        'Schnelles Setup – in 10 Minuten startklar',
        'Automatisierung von Anfang an',
        'Wächst mit Ihrem Team und Umsatz',
        'Investor-ready Reports auf Knopfdruck',
      ]}
      benefits={[
        {
          title: 'Schnell starten',
          description: 'Keine langen Einrichtungsprozesse – legen Sie sofort los.',
        },
        {
          title: 'Skalierbar',
          description: 'Von der GbR zur GmbH – Saldify passt sich Ihrer Rechtsform an.',
        },
        {
          title: 'Investoren überzeugen',
          description: 'Professionelle BWA und Kennzahlen für Ihre Pitch-Decks.',
        },
        {
          title: 'Team-Funktionen',
          description: 'Mehrere Benutzer, Rollen und Berechtigungen für Ihr wachsendes Team.',
        },
        {
          title: 'Integrationen',
          description: 'Verbinden Sie Saldify mit Stripe, PayPal und anderen Tools.',
        },
        {
          title: 'API-Zugang',
          description: 'Bauen Sie eigene Integrationen und automatisieren Sie Workflows.',
        },
      ]}
      useCases={[
        {
          title: 'SaaS-Startups',
          description: 'Wiederkehrende Rechnungen, Subscription-Management und MRR-Tracking.',
        },
        {
          title: 'E-Commerce-Startups',
          description: 'Shop-Anbindung, automatische Rechnungserstellung und Bestandsverwaltung.',
        },
        {
          title: 'Agentur-Gründung',
          description: 'Projektabrechnung, Zeiterfassung und Kundenverwaltung.',
        },
        {
          title: 'Tech-Startups',
          description: 'API-Integration, Automatisierung und Echtzeit-Dashboards.',
        },
      ]}
      features={[
        'Unbegrenzte Rechnungen und Belege',
        'Mehrere Benutzer und Rollen',
        'BWA und Kennzahlen für Investoren',
        'Banking-Integration',
        'ELSTER-Anbindung',
        'API für eigene Integrationen',
        'DATEV-Export für Steuerberater',
        'Echtzeit-Dashboard',
      ]}
      recommendedPlan={{
        name: 'Professional',
        price: '24€/Monat',
        description: 'Ideal für Startups: Unbegrenzte Nutzung, 5 Benutzer, alle Steuermodule und BWA inklusive.',
      }}
      testimonial={{
        quote: 'Bei unserer Series A hatten wir dank Saldify alle Zahlen sofort parat. Das hat die Investoren beeindruckt.',
        author: 'Sarah L.',
        role: 'CEO & Co-Founder',
        company: 'TechStartup GmbH',
      }}
    />
  );
}
